<template>
  <div class="kanbanContainer">
    <div class="kanban" v-if="ready">
      <KanbanCardModal
        v-if="openedCard"
        :card="currentlyOpenedCard"
        @closeKanbanCardModal="
          openedCard = false;
          currentlyOpenedCard = null;
        "
        @updateCardTitle="updateCardTitleFromEmit"
        @updateCardDescription="updateCardDescriptionFromEmit"
        @deleteCard="deleteCard"
      />
      <div class="kanbanNav">
        <input
          class="kanbanTitle"
          v-if="kanban"
          placeholder="Untitled Kanban"
          :value="kanban.title"
          @input="updateKanbanTitle($event, kanban)"
        />
        <div class="selection" v-if="lastSelectedColumn">
          <div class="selectedText">Selected column:</div>
          <div class="selectedColumn">
            {{ lastSelectedColumn.title }}
          </div>
          <button
            class="deleteSelectedColumn"
            v-if="!deletingSelectedColumn"
            @click="deletingSelectedColumn = true"
          >
            {{ deletingSelected ? "Deleting..." : "Delete" }}
          </button>
          <div class="helpers deleteKanban" v-if="deletingSelectedColumn">
            <button
              @click="deleteSelectedColumn()"
              class="deleteSelectedColumn"
              style="font-size: 15px"
            >
              Yes
            </button>
            <button
              @click="deletingSelectedColumn = false"
              class="deleteSelectedColumn"
              style="font-size: 15px"
            >
              No
            </button>
          </div>
          <button
            class="clearSelectedColumn"
            @click="
              lastSelectedColumn = null;
              deletingSelectedColumn = false;
            "
          >
            Clear
          </button>
        </div>
        <button
          v-if="!deletingKanban"
          @click="deletingKanban = true"
          class="tool deleteKanban"
        >
          {{ deleting ? "Deleting..." : "Delete Kanban" }}
        </button>
        <div
          class="helpers deleteKanban deleterContainer"
          v-if="deletingKanban"
        >
          <button @click="deleteKanban()" class="tool helper deleter">
            Yes
          </button>
          <button @click="deletingKanban = false" class="tool helper deleter">
            No
          </button>
        </div>
      </div>
      <div class="columns">
        <Container
          v-if="columns && columns.length"
          orientation="horizontal"
          @drop="onColumnDrop($event)"
          :drop-placeholder="upperDropPlaceholderOptions"
        >
          <Draggable v-for="column in sortedColumns" :key="column._id">
            <div
              class="column"
              @click="
                lastSelectedColumn = column;
                deletingSelectedColumn = false;
              "
            >
              <input
                class="columnTitle"
                :value="column.title ? column.title : 'Untitled column'"
                @input="updateColumnTitle($event, column)"
              />
              <Container
                group-name="col"
                @drop="(e) => onCardDrop(column._id, e)"
                :get-child-payload="getCardPayload(column._id)"
                non-drag-area-selector=".cardTitle"
                drag-class="card-ghost"
                drop-class="card-ghost-drop"
              >
                <Draggable v-for="card in column.cards" :key="card._id">
                  <div class="columnBlock">
                    <input
                      class="columnBlockTitle"
                      placeholder="Untitled card"
                      :value="card.task"
                      @input="updateCardTitle($event, card)"
                    />
                    <div class="card">
                      <textarea
                        class="cardTitle"
                        placeholder="No description"
                        :value="card.description"
                        @input="updateCardDescription($event, card)"
                      ></textarea>
                      <button
                        class="deleteSelectedColumn"
                        style="margin-left: unset"
                        :disabled="openedCard"
                        @click="
                          openedCard = true;
                          currentlyOpenedCard = card;
                        "
                      >
                        Open
                      </button>
                    </div>
                  </div>
                </Draggable>
              </Container>
              <div class="columnBlock newCard" @click="createNewCard(column)">
                <div class="columnBlockTitle">+ New Card</div>
              </div>
            </div>
          </Draggable>
        </Container>
        <div class="newColumn" @click="createNewColumn">
          <div class="newColumnBlock">+ New Column</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Container, Draggable } from "vue-smooth-dnd";
import { applyDrag, mergedKanbanColumnsAndCards } from "./KanbanUtilities";
import KanbanCardModal from "./KanbanCardModal";
import {
  getKanban,
  createNewColumn,
  createNewCard,
  getKanbanColumnsAndCards,
  updateColumnTitle,
  updateCardTitle,
  updateCardDescription,
  updateKanbanTitle,
  updateColumnIndexes,
  updateCardLocations,
  deleteKanban,
  deleteSelectedColumn,
  deleteCard,
} from "./KanbanHelpers";

export default {
  name: "KanbanSingle",
  data() {
    return {
      ready: false,

      deletingSelectedColumn: false,
      deletingSelected: false,

      deletingKanban: false,
      deleting: false,

      lastSelectedColumn: null,
      openedCard: null,
      currentlyOpenedCard: null,

      kanban: null,
      title: "Untitled Kanban",
      description: "",
      columns: [],

      defaults: {
        scopeEnabled: false,
      },

      upperDropPlaceholderOptions: {
        className: "cards-drop-preview",
        animationDuration: "150",
        showOnTop: true,
      },
      dropPlaceholderOptions: {
        className: "drop-preview",
        animationDuration: "150",
        showOnTop: true,
      },
    };
  },
  components: {
    Container,
    Draggable,
    KanbanCardModal,
  },
  computed: {
    sortedColumns() {
      let columns = this.columns;
      const kanbanId = this.$route.params.kanbanId;
      columns.sort(function (a, b) {
        let columnAIndex = null;
        let columnBIndex = null;
        for (var x = 0; x < a.kanbans.length; x++) {
          let kanban = a.kanbans[x];
          if (kanban.kanbanId == kanbanId) {
            columnAIndex = kanban.columnIndex;
          }
        }
        for (var y = 0; y < b.kanbans.length; y++) {
          let kanban = b.kanbans[y];
          if (kanban.kanbanId == kanbanId) {
            columnBIndex = kanban.columnIndex;
          }
        }
        return columnAIndex - columnBIndex;
      });
      return columns;
    },
  },
  async created() {
    const kanbanId = this.$route.params.kanbanId;
    this.kanban = await getKanban(kanbanId);
    if (this.kanban.title) {
      this.title = this.kanban.title;
    }
    if (this.kanban.description) {
      this.description = this.kanban.description;
    }

    
    const { columns, cards } = await getKanbanColumnsAndCards(kanbanId);
    this.columns = mergedKanbanColumnsAndCards(columns, cards, kanbanId);
    this.ready = true;
  },
  methods: {
    async updateKanbanTitle($event, kanban) {
      kanban.title = $event.target.value;
      await updateKanbanTitle(kanban._id, $event.target.value);
    },
    async updateColumnTitle($event, column) {
      this.lastSelectedColumn = column;
      column.title = $event.target.value;
      await updateColumnTitle(column._id, $event.target.value);
    },
    async updateCardTitleFromEmit(emitData) {
      await this.updateCardTitle(emitData.event, emitData.card);
    },
    async updateCardDescriptionFromEmit(emitData) {
      await this.updateCardDescription(emitData.event, emitData.card);
    },
    async updateCardTitle($event, card) {
      card.task = $event.target.value;
      await updateCardTitle(card._id, $event.target.value);
    },
    async updateCardDescription($event, card) {
      card.description = $event.target.value;
      await updateCardDescription(card._id, $event.target.value);
    },
    async deleteKanban() {
      this.deletingKanban = false;
      this.deleting = true;
      const kanbanId = this.$route.params.kanbanId;
      await deleteKanban(kanbanId);
      this.deleting = false;
      this.$router.push("/");
    },
    async deleteCard(card) {
      this.openedCard = null;
      this.currentlyOpenedCard = null;
      await deleteCard(card._id);
      for (var x = this.columns.length - 1; x > -1; x--) {
        const column = this.columns[x];
        for (var i = column.cards.length - 1; i > -1; i--) {
          const columnCard = column.cards[i];
          if (columnCard._id == card._id) {
            column.cards.splice(i, 1);
          }
        }
      }
    },
    async deleteSelectedColumn() {
      this.deletingSelectedColumn = false;
      this.deletingSelected = true;
      const kanbanId = this.$route.params.kanbanId;
      const columnId = this.lastSelectedColumn._id;
      await deleteSelectedColumn(kanbanId, columnId);
      this.deletingSelected = false;
      this.lastSelectedColumn = null;
      for (var x = this.columns.length - 1; x > -1; x--) {
        const column = this.columns[x];
        if (column._id == columnId) {
          this.columns.splice(x, 1);
        }
      }
    },

    async onColumnDrop(dropResult) {
      let columns = this.columns;
      columns = applyDrag(columns, dropResult);
      const kanbanId = this.$route.params.kanbanId;
      let columnIndexesData = [];
      /* For each column */
      for (var i = 0; i < columns.length; i++) {
        let column = columns[i];
        /* For each associated kanban value in a column */
        for (var j = 0; j < column.kanbans.length; j++) {
          let kanban = column.kanbans[j];
          /* If kanban set matches current kanban */
          if (kanban.kanbanId == kanbanId) {
            /* Pack new index && column id */
            kanban.columnIndex = i;
            let columnData = {
              newIndex: i,
              columnId: column._id,
            };
            columnIndexesData.push(columnData);
          }
        }
      }
      this.columns = columns;
      await updateColumnIndexes(kanbanId, columnIndexesData);
    },
    async onCardDrop(columnId, dropResult) {
      if (dropResult.removedIndex !== null || dropResult.addedIndex !== null) {
        console.log("dropResult", dropResult);
        let oldColumnId = null;
        const kanbanId = this.$route.params.kanbanId;
        let initialCard = dropResult.payload;
        for (var x = 0; x < initialCard.lists.length; x++) {
          let list = initialCard.lists[x];
          if (list.kanbanId == kanbanId) {
            oldColumnId = list.listId;
          }
        }
        let columns = this.columns;
        const column = columns.filter((p) => p._id === columnId)[0];
        const columnIndex = columns.indexOf(column);
        const newColumn = Object.assign({}, column);
        newColumn.cards = applyDrag(newColumn.cards, dropResult);
        columns.splice(columnIndex, 1, newColumn);

        /* Update local data for computed */
        let cardLocationsData = [];
        for (var i = 0; i < newColumn.cards.length; i++) {
          let card = newColumn.cards[i];
          for (var k = 0; k < card.lists.length; k++) {
            let list = card.lists[k];
            if (list.kanbanId == kanbanId && list.listId == oldColumnId) {
              console.log("@1", list.listId, list.listIndex);
              list.listId = columnId;
              list.listIndex = i;
              console.log("@2", list.listId, list.listIndex);
              let cardData = {
                newIndex: i,
                cardId: card._id,
                columnId: columnId,
              };
              console.log("@3", cardData);
              cardLocationsData.push(cardData);
            }
          }
        }

        this.columns = columns;
        await updateCardLocations(kanbanId, cardLocationsData);
      }
    },
    getCardPayload(columnId) {
      return (index) => {
        return this.columns.filter((p) => p._id === columnId)[0].cards[index];
      };
    },
    async createNewCard(column) {
      const kanbanId = this.$route.params.kanbanId;
      const columnId = column._id;
      let cardIndex = 0;
      if (column.cards && column.cards.length) {
        cardIndex = column.cards.length;
      }
      const scopeEnabled = this.defaults.scopeEnabled;
      const card = await createNewCard(
        kanbanId,
        cardIndex,
        columnId,
        scopeEnabled
      );
      column.cards.push(card);
    },
    async createNewColumn() {
      const kanbanId = this.$route.params.kanbanId;
      let newColumnIndex = 0;
      if (this.columns && this.columns.length) {
        newColumnIndex = this.columns.length; // not to -1, as we need next index, not current
      }
      const scopeEnabled = this.defaults.scopeEnabled;
      let column = await createNewColumn(
        kanbanId,
        newColumnIndex,
        scopeEnabled
      );
      column.cards = []; // so there's a cards slot to push into
      if (!this.columns || !this.columns.length) {
        this.columns = [];
      }
      this.columns.push(column);
    },
  },
};
</script>

<style scoped>
.kanbanContainer {
  height: calc(100vh - 36px);
}
.kanban {
  height: calc(100vh - 36px);
}
.kanbanTitle {
  margin-left: 10px;
  font-size: 30px;
  border: none;
  max-width: 800px;
  width: 100%;
}
.columns {
  height: calc(100vh - 80px);
  display: flex;
  margin-top: 10px;
  overflow-y: hidden;
}
.column {
  height: calc(100vh - 90px);
  width: 320px;
  margin: 0px 10px;
  padding: 10px 0px;
  border: 1px solid #333333;
  background-color: white;
  overflow: hidden;
}
.columnTitle {
  font-size: 24px;
  border: none;
  width: calc(100% - 30px);
  padding-bottom: 0px;
  margin-left: 15px;
  margin-right: auto;
  margin-bottom: 5px;
}
.columnBlock {
  border: 1px solid #333;
  padding: 10px;
  margin: 5px 0px;
  background-color: white;
}
.columnBlockTitle {
  font-size: 18px;
  border: none;
  width: 100%;
}

.cardTitle {
  border: none;
  width: 100%;
  max-width: 276px;
  margin-top: 2px;
}

.newCard {
  border-style: dashed;
  cursor: pointer;
  margin-left: 10px;
  padding: 12px 10px;
  margin-right: 10px;
  box-shadow: 0px -1px 6px 1px #86868626;
}

.columnBlock.newCard .columnBlockTitle {
  font-size: 19px;
}

.newCard:hover {
  background-color: #fffaf3;
}

.newColumn {
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  padding: 15px;
  cursor: pointer;
  border-style: dashed;
  width: 320px;
  margin: 0px 10px;
  border: 1px dashed #333333;
}

.newColumn:hover {
  background-color: #fffaf3;
}

.newColumnBlock {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: unset;
  padding: 10px;
  font-size: 20px;
}

.tool {
  width: 150px;
  cursor: pointer;
  font-size: 20px;
}

.kanbanNav {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.deleteKanban {
  font-size: 14px;
  border: none;
  margin-right: 5px;
}

.deleterContainer {
  width: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.deleter {
  /* margin: 6px 4px; */
}
.helpers {
  display: flex;
  align-items: center;
}
.helper {
  font-size: 16px;
  width: 60px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2px;
  margin-bottom: 2px;
}

.selection {
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: 25px;
}

.selectedText {
  font-size: 14px;
  margin-right: 5px;
}

.selectedColumn {
  margin-top: auto;
  margin-bottom: auto;
  border: 1px solid blue;
  padding: 6px 12px;
}

.deleteSelectedColumn,
.clearSelectedColumn {
  margin-left: 10px;
  border: none;
  cursor: pointer;
}

.drop-preview {
  background-color: rgba(150, 150, 200, 0.1);
  border: 1px dashed #abc;
  margin: 5px;
}

.cards-drop-preview {
  background-color: rgba(150, 150, 200, 0.1);
  border: 1px dashed #abc;
  margin: 5px 45px 5px 5px;
}

.card-ghost {
  transition: transform 0.18s ease;
  /* transform: rotateZ(5deg); */
  cursor: move;
}

.card-ghost-drop {
  transition: transform 0.18s ease-in-out;
  /* transform: rotateZ(0deg); */
}
.smooth-dnd-container {
  position: relative !important;
  min-height: 30px !important;
  min-width: 30px !important;
  overflow: scroll !important;
  height: calc(100vh - 195px) !important;
  padding: 0px 15px !important;
}
.smooth-dnd-container.horizontal {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
</style>